import React from "react"
import { BsArrowRight } from "react-icons/bs"
import { Link } from "react-router-dom"

const Footer = () => {
  return (
    <footer data-scroll-section className="footer">
      <div className="wrapper footer-wrapper">
        <div className="footer-grid">
          <div className="newsletter footer-newsletter">
            <h2 className="title-md">Keep in touch</h2>
            <p>Subscribe to our newsletter and we'll keep you updated.</p>
            <form className="newsletter-form">
              <input
                required
                type="email"
                name="email"
                id="email"
                placeholder="your email"
              />
              <button type="submit">
                <BsArrowRight />
              </button>
            </form>
            <img src="/imgs/payment.png" alt="payment methods" />
          </div>
          <div className="footer-links">
            <ul>
              <p>Help</p>
              <li>Payments</li>
              <li>Shopping</li>
              <li>Contact</li>
            </ul>
            <ul>
              <p>Explore</p>
              <li>
                <Link to="/">Shop</Link>
              </li>
              <li>
                <Link to="/">Culture</Link>
              </li>
              <li>
                <Link to="/">About</Link>
              </li>
            </ul>
            <ul>
              <p>Socials</p>
              <li>Instagram</li>
              <li>Tiktok</li>
              <li>Youtube</li>
            </ul>
          </div>
        </div>
        <div className="footer-copyright">
          <p>© 2023 Dallol The Brand</p>
          <p>Made by Leul Michael</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
